module.exports = __webpack_public_path__ + "img/img_guide_delete_account_4.3fe2a989.png";